import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { Weekday } from "./CalendarProvider";

interface YasumiProviderIndexResource {
	id: Id;
	label: string;
}
export interface EventCalendarSettingUpdateResource {
	id: Id;
	showCalendarWeeks: boolean;
	showHolidays: boolean;
	startDayOfTheWeek: Weekday;
	yasumiProvider: YasumiProviderIndexResource;
}

export interface EventCalendarSettingSaveRequest {
	showCalendarWeeks: boolean;
	showHolidays: boolean;
	startDayOfTheWeek: Weekday;
	yasumiProviderId: Id;
}

export interface EventCalendarSettingFormValues {
	showCalendarWeeks: boolean;
	showHolidays: boolean;
	startDayOfTheWeek: Weekday;
	yasumiProvider: YasumiProviderIndexResource;
}

const baseKey = "event-calendar-settings";

export const eventCalendarSettingService = {
	showKey: [baseKey],
	show: () => {
		return axios.get<LaravelResponse<EventCalendarSettingUpdateResource>>(keyToUrl([baseKey]));
	},
	update: (entity: EventCalendarSettingSaveRequest) => {
		return axios.put(keyToUrl([baseKey]), entity);
	},
};
